import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getWarehouseList(params) {
  return request({
    url: URL.partner.warehouse,
    method: 'get',
    params
  })
}

export function saveWarehouse(data) {
  return request({
    url: URL.partner.warehouse,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delWarehouse(uuid) {
  return request({
    url: URL.partner.warehouse + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
